import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c36f8cd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "category-wizard__container" }
const _hoisted_2 = { class: "category-wizard__steps" }
const _hoisted_3 = { class: "category-wizard__steps-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "category-wizard-step__label" }
const _hoisted_6 = { class: "category-wizard-step__circles" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "category-wizard-step__circle category-wizard-step__circle--point" }, null, -1))
const _hoisted_8 = { class: "category-wizard__final-step" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-disabled': _ctx.disabled }, "category-wizard"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step.value,
              class: _normalizeClass([{
              'is-active': _ctx.currentStep === index,
              'is-checked': _ctx.isStepChecked(step),
              'is-clickable': index <= _ctx.maxIndexRetched + 1,
            }, "category-wizard-step"]),
              onClick: ($event: any) => (_ctx.stepClickHandler(index))
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(step.label), 1),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", {
                  class: _normalizeClass([{
                  'is-visible':
                    index <= _ctx.currentStep || index <= _ctx.higherCheckedIndex,
                  'is-checked': _ctx.isStepChecked(step),
                  'is-active': _ctx.currentStep === index,
                  'is-clickable': index <= _ctx.maxIndexRetched + 1,
                }, "category-wizard-step__circle category-wizard-step__circle--bigger"]),
                  style: _normalizeStyle(_ctx.stepCircleStyle(step))
                }, null, 6)
              ])
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", {
          style: _normalizeStyle(_ctx.progressStyle),
          class: "category-wizard__progress"
        }, null, 4),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("selfAssessment.assessment.wizard.finalStep")), 1)
      ])
    ])
  ], 2))
}